module.exports = __webpack_public_path__ + "static/media/gpvnl-logo.751b883e.png";